import React, { useState, useRef } from 'react';
import { SafeAreaView, View, StyleSheet, KeyboardAvoidingView, ScrollView, Platform, TouchableOpacity, Image, Text, TextInput, Alert, ActivityIndicator } from 'react-native';
import CommonPage from '../components/CommonPage';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { Picker } from '@react-native-picker/picker';
import DateTimePicker from '@react-native-community/datetimepicker';
import RBSheet from "react-native-raw-bottom-sheet";
import * as ImagePicker from 'expo-image-picker';
import {updateUserInfo} from '../services/apiCall'
import { useNavigation } from "@react-navigation/native";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

let ToastAndroid;
if (Platform.OS === 'android' || Platform.OS === 'ios') {
  ToastAndroid = lazy(() => import('react-native'));
}


const CreateProfile = () => {
  const [userName, setUserName] = useState('');
  const [gender, setGender] = useState('');
  const [birthDate, setBirthDate] = useState(new Date());
  const [birthTime, setBirthTime] = useState(new Date());
  const [birthPlace, setBirthPlace] = useState('');
  const [image, setImage] = useState('https://sgpublicbucket.s3.ap-south-1.amazonaws.com/profile.jpeg');
  const [loading, setLoading] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showTimePicker, setShowTimePicker] = useState(false);

  const refRBSheet = useRef();
  const navigation =useNavigation();

  const handleUpdateUserInfo = async () => {
    setLoading(true);
    const userData = {
        name: userName,
        birth_date: birthDate.toISOString(),
        birth_place: birthPlace,
        birth_time: birthTime.toISOString(),
        gender: gender,
        profile_image: image.base64,
      };
    try {
      const response = await updateUserInfo(userData);
      if (Platform.OS === 'android') {
        ToastAndroid.show('User info updated successfully', ToastAndroid.SHORT);
      } else {
        Alert.alert('Success', 'User info updated successfully'); 
      }
      if(response?.success){
        navigation.navigate('HomeDrawer');
      }
      
    //   Alert.alert('Success', 'User info updated successfully');
      setLoading(false);
    } catch (error) {
        setLoading(false);
        if (Platform.OS === 'android') {
          ToastAndroid.show('Failed to update user info', ToastAndroid.SHORT);
        } else {
          Alert.alert('Error', 'Failed to update user info'); 
        }
    //   Alert.alert('Error', 'Failed to update user info');
      console.error('Error updating user info:', error);
    }
  };

  const pickImage = async () => {
    refRBSheet.current.close();
    const permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();

    if (!permissionResult.granted) {
      alert("Permission to access gallery is required!");
      return;
    }

    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: false,
      aspect: [1, 1],
      quality: 0.7,
      base64: true,
      exif: false
    });

    if (!result.canceled) {
      setImage(result.assets[0]);
    //   console.log(result.assets[0].base64);
    }
  };

  const takePhoto = async () => {
    refRBSheet.current.close();
    const permissionResult = await ImagePicker.requestCameraPermissionsAsync();

    if (!permissionResult.granted) {
      alert("Permission to access camera is required!");
      return;
    }

    const result = await ImagePicker.launchCameraAsync({
      allowsEditing: false,
      aspect: [1, 1],
      quality: 0.7,
      base64: true,
      exif: false
    });

    if (!result.canceled) {
      setImage(result.assets[0]);
    //   console.log(result.assets[0].base64);
    }
  };

  const handleImagePick = async (type) => {
    let result;
    if (type === 'camera') {
        takePhoto();
    } else {
        pickImage();
    }

    if (!result.canceled) {
      setImage(result.uri);
    }
    
  };

  const handleSave = () => {

    if (!userName) {
        ToastAndroid.show('Please enter your name.', ToastAndroid.SHORT);
        return;
      }
      if (!gender) {
        ToastAndroid.show('Please select your gender.', ToastAndroid.SHORT);
        return;
      }
      if (!birthPlace) {
        ToastAndroid.show('Please enter your birth place.', ToastAndroid.SHORT);
        return;
      }
      if (!birthDate) {
        ToastAndroid.show('Please select your birth date.', ToastAndroid.SHORT);
        return;
      }
      if (!birthTime) {
        ToastAndroid.show('Please select your birth time.', ToastAndroid.SHORT);
        return;
      }
      if (!image) {
        ToastAndroid.show('Please select a profile image.', ToastAndroid.SHORT);
        return;
      }
 
    handleUpdateUserInfo();
  };

  return (
    <SafeAreaView style={styles.container}>
      <CommonPage headerText='Create Profile' drawerIconVisible={false}>
        <SafeAreaView style={{ flex: 1 }}>
          <KeyboardAvoidingView
            keyboardVerticalOffset={Platform.OS === 'ios' ? 64 : 0}
            behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
            style={{ flex: 1 }}
          >
            <ScrollView
              contentContainerStyle={{ flexGrow: 1 }}
              keyboardShouldPersistTaps="handled"
            >
              <View style={styles.imagePickerContainer}>
                <TouchableOpacity
                  style={styles.imagePicker}
                  onPress={() => refRBSheet.current.open()}
                >
                  <Image source={{ uri: image?.uri !==undefined ? image.uri : image }} style={styles.image} />
                </TouchableOpacity>
                <TouchableOpacity style={styles.editIconContainer}  onPress={() => refRBSheet.current.open()}>
                  <MaterialCommunityIcons
                    name={'pencil-outline'}
                    color={'#000'}
                    size={15}
                  />
                  <Text style={styles.editText}>
                    Edit
                  </Text>
                </TouchableOpacity>
              </View>

              <View style={styles.inputContainer}>
                <Text style={styles.inputLabel}>
                  Enter Your Name
                </Text>
                <TextInput
                  style={styles.input}
                  placeholder="Enter Your Name"
                  placeholderTextColor="gray"
                  value={userName}
                  onChangeText={setUserName}
                />
              </View>

              <View style={styles.inputContainer}>
                <Text style={styles.inputLabel}>
                  Gender
                </Text>
                <View style={styles.pickerContainer}>
                  <Picker
                    selectedValue={gender}
                    style={styles.picker}
                    itemStyle={{fontWeight: '400',
                        fontSize: 18,}}
                    onValueChange={(itemValue) => setGender(itemValue)}
                  >
              <Picker.Item label="Select Your gender" value="" style={{fontWeight: '400',
    fontSize: 18,}} />
                    <Picker.Item label="Male" value="male" style={{fontWeight: '400',
    fontSize: 18,}}/>
                    <Picker.Item label="Female" value="female" style={{fontWeight: '400',
    fontSize: 18,}}/>
                  </Picker>
                </View>
              </View>

              <View style={styles.inputContainer}>
                <Text style={styles.inputLabel}>
                Enter Your Birth Place
                </Text>
                <TextInput
                  style={styles.input}
                  placeholder="Enter Your Birth Place"
                  placeholderTextColor="gray"
                  value={birthPlace}
                  onChangeText={setBirthPlace}
                />
              </View>

              <View style={styles.inputContainer}>
                <Text style={styles.inputLabel}>
                  Birth Date
                </Text>
                <View style={styles.dateviewContainer}>
                  {Platform.OS === 'web' ? (
                    <DatePicker
                      selected={birthDate}
                      onChange={(date) => setBirthDate(date)}
                      dateFormat="yyyy/MM/dd"
                      showYearDropdown
                      scrollableYearDropdown
                      showIcon
                      toggleCalendarOnIconClick
                    />
                  ) : (
                    <>
                      <TouchableOpacity onPress={() => setShowDatePicker(true)}>
                        <Text>{birthDate.toDateString()}</Text>
                      </TouchableOpacity>
                      {showDatePicker && (
                        <DateTimePicker
                          value={birthDate}
                          mode="date"
                          display="default"
                          onChange={(event, selectedDate) => {
                            setShowDatePicker(false);
                            if (selectedDate) {
                              setBirthDate(selectedDate);
                            }
                          }}
                        />
                      )}
                    </>
                  )}
                </View>
              </View>

              <View style={styles.inputContainer}>
                <Text style={styles.inputLabel}>
                  Birth Time
                </Text>
                <View style={styles.dateviewContainer}>
                  {Platform.OS === 'web' ? (
                  //  <View style={{ width: '100%', backgroundColor: 'white', borderWidth: 0 }}>
                   <DatePicker
                     selected={birthTime}
                     onChange={(time) => setBirthTime(time)}
                     showTimeSelect
                     showTimeSelectOnly
                     timeIntervals={15}
                     timeCaption="Time"
                     dateFormat="h:mm aa"
                     showIcon
                     toggleCalendarOnIconClick
                     style={{ borderWidth: 0, width: '100%', }} // Make sure the DatePicker has no border as well
                   />
                //  </View>

                  ) : (
                    <>
                      <TouchableOpacity onPress={() => setShowTimePicker(true)}>
                        <Text>{birthTime.toLocaleTimeString()}</Text>
                      </TouchableOpacity>
                      {showTimePicker && (
                        <DateTimePicker
                          value={birthTime}
                          mode="time"
                          display="default"
                          onChange={(event, selectedTime) => {
                            setShowTimePicker(false);
                            if (selectedTime) {
                              setBirthTime(selectedTime);
                            }
                          }}
                        />
                      )}
                    </>
                  )}
                </View>
              </View>



              <View style={styles.saveButtonContainer}>
                <TouchableOpacity 
                  style={styles.saveButton}
                  onPress={handleSave}
                  disabled={loading}
                >
                  {loading ? (
                    <ActivityIndicator size="small" color="#000" />
                  ) : (
                    <Text style={styles.saveButtonText}>
                      Save
                    </Text>
                  )}
                </TouchableOpacity>
              </View>
            </ScrollView>
          </KeyboardAvoidingView>
        </SafeAreaView>
      </CommonPage>

      <RBSheet
        ref={refRBSheet}
        closeOnDragDown={true}
        closeOnPressMask={true}
        height={200}
        customStyles={{
          wrapper: {
            backgroundColor: "rgba(0,0,0,0.5)"
          },
          draggableIcon: {
            backgroundColor: "#000"
          }
        }}
      >
        <View style={styles.sheetContainer}>
          <TouchableOpacity 
            style={styles.sheetButton} 
            onPress={() => handleImagePick('camera')}
          >
            <MaterialCommunityIcons name="camera" size={24} color="black" />
            <Text style={styles.sheetButtonText}>Take Photo</Text>
          </TouchableOpacity>
          <TouchableOpacity 
            style={styles.sheetButton} 
            onPress={() => handleImagePick('library')}
          >
            <MaterialCommunityIcons name="image" size={24} color="black" />
            <Text style={styles.sheetButtonText}>Choose Image</Text>
          </TouchableOpacity>
        </View>
      </RBSheet>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  imagePickerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 30
  },
  imagePicker: {
    width: 100,
    height: 100,
    borderRadius: 50,
    borderWidth: 3,
    borderColor: 'white',
    padding: 5,
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: 90,
    height: 90,
    borderRadius: 45
  },
  editIconContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5
  },
  editText: {
    fontSize: 20,
    fontWeight: '500',
  },
  inputContainer: {
    marginTop: 20,
    marginHorizontal: 20
  },
  inputLabel: {
    color: '#000',
    fontSize: 20,
    fontWeight: '500',
    marginBottom:5
  },
  input: {
    color: '#000',
    padding: 15,
    backgroundColor: '#fff',
    borderRadius: 10,
    width: '100%',
    fontWeight: '400',
    fontSize: 18,
  },
  pickerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 10,
    width: '100%',
    justifyContent: 'center',

  },
  dateviewContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 10,
    width: '100%',
    justifyContent: 'center',
    padding: 15,
  },
  picker: {
    // height: 50,
    flex: 1,
    padding: 15,
    fontSize: 20
  },
  pickerText: {
    flex: 1,
    color: '#000',
    fontWeight: '400',
    fontSize: 18,
  },
  pickerIcon: {
    backgroundColor: '#f0df21',
    borderRadius: 15,
    padding: 5
  },
  saveButtonContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 10
  },
  saveButton: {
    backgroundColor: "#f0df21",
    paddingVertical: 10,
    paddingHorizontal: 35,
    borderRadius: 30
  },
  saveButtonText: {
    fontSize: 20,
    fontWeight: '700'
  },
  sheetContainer: {
    padding: 20
  },
  sheetButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10
  },
  sheetButtonText: {
    marginLeft: 10,
    fontSize: 20
  }
});

export default CreateProfile;
